import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { MoreHorizontal } from 'lucide-react';
import styles from './NotificationItem.module.scss';

/**
 * One notification row, used by the bell panel ("compact") and the
 * notifications page. Content comes from getNotificationContent().
 */
const NotificationItem = ({
  id,
  content,
  unread,
  time,
  compact,
  highlightIcon,
  onOpen,
  onMarkAsRead,
  onDelete,
}) => {
  const Icon = content.icon;
  const hasMenu = !compact && (onMarkAsRead || onDelete);

  return (
    <li className={`${styles.item} ${compact ? styles.compact : ''}`}>
      <a
        href={content.href}
        className={styles.main}
        onClick={(event) => onOpen && onOpen(event)}
      >
        <span
          className={`${styles.icon} ${highlightIcon ? styles.highlight : ''}`}
          aria-hidden="true"
        >
          <Icon size={18} strokeWidth={2} />
        </span>
        <span className={styles.text}>
          <span className={`${styles.title} ${unread ? styles.unread : ''}`}>
            {content.title}
          </span>
          <span className={styles.body}>{content.body}</span>
          <span className={styles.meta}>
            {!compact && content.cta && (
              <span className={styles.cta}>{content.cta}</span>
            )}
            {time && <span>{time}</span>}
          </span>
        </span>
        <span
          className={`${styles.dot} ${unread ? styles.dotUnread : ''}`}
          aria-hidden="true"
        />
        {unread && <span className="sr-only">Unread</span>}
      </a>
      {hasMenu && (
        <Dropdown
          id={`notification-${id}-menu`}
          pullRight
          className={styles.menu}
        >
          <Dropdown.Toggle
            noCaret
            bsStyle="link"
            className={styles.menuToggle}
            aria-label="Notification options"
          >
            <MoreHorizontal size={18} aria-hidden="true" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {unread && onMarkAsRead && (
              <MenuItem onClick={onMarkAsRead}>Mark as read</MenuItem>
            )}
            {onDelete && <MenuItem onClick={onDelete}>Remove</MenuItem>}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </li>
  );
};

NotificationItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  content: PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    cta: PropTypes.string,
    href: PropTypes.string,
  }).isRequired,
  unread: PropTypes.bool,
  time: PropTypes.string,
  compact: PropTypes.bool,
  highlightIcon: PropTypes.bool,
  onOpen: PropTypes.func,
  onMarkAsRead: PropTypes.func,
  onDelete: PropTypes.func,
};

export default NotificationItem;
